var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "home",
      style: _vm.$store.getters["customizer/getHomeStyles"]
    },
    [
      _c(
        "div",
        {
          staticClass: "header",
          style: _vm.$store.getters["customizer/getHeadlineTextStyles"]
        },
        [
          _c(
            "div",
            {
              staticClass: "header__date-time",
              style: _vm.$store.getters["customizer/getDateStyles"]
            },
            [
              _vm.$store.state.customizer.isShowDate &&
              _vm.$store.state.customizer.isShowHeadline
                ? _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$store.getters.getHeaderDate(_vm.getLanguageDate)
                      ) +
                        " " +
                        _vm._s(
                          _vm.$store.getters.getHeaderTime(_vm.getLanguageDate)
                        )
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.state.customizer.isShowDate &&
              !_vm.$store.state.customizer.isShowHeadline
                ? _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$store.getters.getHeaderDate(_vm.getLanguageDate)
                      )
                    ),
                    _c("br"),
                    _vm._v(
                      _vm._s(
                        _vm.$store.getters.getHeaderTime(_vm.getLanguageDate)
                      )
                    )
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _vm.$store.state.customizer.isShowRoomHeader
            ? _c("div", { staticClass: "header__room" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.getRoomName) +
                    ": " +
                    _vm._s(_vm.$store.state.device.room) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "header__lang" }, [
            _c(
              "div",
              {
                staticClass: "header__lang-select-wrapper",
                class: {
                  "header__lang-select-wrapper--active": _vm.getIsFocusOnLang
                },
                style: _vm.getLangStyles(_vm.getIsFocusOnLang)
              },
              [
                _c("img", {
                  staticClass: "header__lang-icon",
                  style: _vm.$store.getters["customizer/getLangImgStyle"],
                  attrs: { src: _vm.getLanguageIcon }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "header__lang-name" }, [
                  _vm._v(_vm._s(_vm.getLanguageName))
                ])
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.$store.state.customizer.isShowRoom
        ? _c(
            "div",
            {
              staticClass: "roomname",
              style: _vm.$store.getters["customizer/getRoomnameTextStyles"]
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.getRoomName) +
                  " " +
                  _vm._s(_vm.$store.state.device.room) +
                  "\n  "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$store.state.customizer.isShowBuilding
        ? _c(
            "div",
            {
              staticClass: "buildingname",
              style: _vm.$store.getters["customizer/getHotelnameTextStyles"]
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$store.state.customizer.headline) +
                  "\n  "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("Navigation", {
        attrs: {
          menuItems: _vm.getMainMenu,
          "active-item-index": _vm.getActiveItemIndex,
          "is-active": _vm.getIsFocusOnNav
        }
      }),
      _vm._v(" "),
      _vm.osdVisible
        ? _c("div", { staticClass: "osd-overlay" }, [
            _c("div", { staticClass: "osd-content" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.getChannelName) +
                  ": " +
                  _vm._s(_vm.osdChannel) +
                  "\n    "
              )
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a90ec03", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a90ec03","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = null
// module chunks = 